module.exports = __webpack_public_path__ + "img/thumbnail-4.ae12c4ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-4.jpg
// module id = AMpf
// module chunks = 1